import React, {createContext, useEffect } from 'react';
import { createStore, createHook } from 'react-sweet-state';
import {apiGetAuditProducts} from "@bdfx/audit-api"

import {getAuditId} from "../../common/helpers"
import {getFilters} from "../helpers"

const initialState = {
  data: {},
  loading: false,
  loaded: false,
  error: null,
};

const actions = {
  fetch: (page) => async ({ getState, setState }) => {
    if (getState().loading) return;
    setState({ loading: true }); 
    try {
      const id: string = getAuditId()
      const filter = getFilters()

      const preData = getState().data
      
      const {data} = await apiGetAuditProducts(id, {filter: [filter], page: page });
      setState({ data: {...preData,[id]: {...preData[id], [filter]: data }}, loading: false });
      await new Promise(r => setTimeout(r, 10000))
    } catch (error) { 
      await new Promise(r => setTimeout(r, 10000)).then(
        () => {
          console.error(error)
          setState({ error, loading: false });  
        }
      );
    } 
  }
} 

// create a store type
const ProductsStore = createStore({ initialState, actions });
// create components to access store state instances
const useProducts = createHook(ProductsStore);

export const ProductsContext = createContext({});

export const ProductsProvider = (props) => {
    const [state, actions] = useProducts();
    const filter = getFilters()
    const id = getAuditId()

    useEffect(() => { 
          if(!state.data?.[id]?.[filter]) {
            actions.fetch(1)
          }
    }, [state,actions,id,filter]);
  
    return (
      <ProductsContext.Provider value={[state.data?.[id]?.[filter], actions.fetch, state.loading]}>
        {props.children}
      </ProductsContext.Provider>
    );
  };
